import React from "react";
import Login from "../pages/login/login";
import RegisterAdmin from "../pages/register/registerAdmin";
import { Provider } from 'react-redux';
import { store } from '../redux/store';
import './App.css';
import ResponsiveAppBar from "../components/Dashboard/appBar/appBar";
import { AuthProvider } from "../redux/context/authProvider";
import ProtectedRoutes from "../hooks/Auth/RequiredAuth"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import {ROLES_PAGES} from "../redux/context/allowedTypes";
import Logs from "../pages/DashboardPages/siteLogs";
import Users from "../pages/DashboardPages/users";
import Sites from "../pages/DashboardPages/sites";
import RtkStation from "../pages/DashboardPages/rtkStation";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Provider store={store}>
          <div>
            <ResponsiveAppBar />
            <Routes>
              {/* public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/login" replace />} />

              {/* protected routes */}
              <Route
                path="/register_admin"
                element={
                  <ProtectedRoutes allowed={ROLES_PAGES.register}>
                    <RegisterAdmin />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/logs"
                element={
                  <ProtectedRoutes allowed={ROLES_PAGES.register}>
                    <Logs />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoutes allowed={ROLES_PAGES.register}>
                    <Users />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/sites"
                element={
                  <ProtectedRoutes allowed={ROLES_PAGES.sites}>
                    <Sites />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/rtk_stations"
                element={
                  <ProtectedRoutes allowed={ROLES_PAGES.rtk_stations}>
                    <RtkStation />
                  </ProtectedRoutes>
                }
              />
            </Routes>
          </div>
        </Provider>
      </AuthProvider>
    </Router>
  );
}

export default App;
